export default __webpack_public_path__ + "static/media/image@3x.238e849e.jpg";